var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4981 7.33969C18.4381 7.32969 18.3681 7.32969 18.3081 7.33969C16.9281 7.28969 15.8281 6.15969 15.8281 4.75969C15.8281 3.32969 16.9781 2.17969 18.4081 2.17969C19.8381 2.17969 20.9881 3.33969 20.9881 4.75969C20.9781 6.15969 19.8781 7.28969 18.4981 7.33969Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4675 14.6198C18.8375 14.8498 20.3475 14.6098 21.4075 13.8998C22.8175 12.9598 22.8175 11.4198 21.4075 10.4798C20.3375 9.76985 18.8075 9.52984 17.4375 9.76984",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47047 7.33969C6.53047 7.32969 6.60047 7.32969 6.66047 7.33969C8.04047 7.28969 9.14047 6.15969 9.14047 4.75969C9.14047 3.32969 7.99047 2.17969 6.56047 2.17969C5.13047 2.17969 3.98047 3.33969 3.98047 4.75969C3.99047 6.15969 5.09047 7.28969 6.47047 7.33969Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5014 14.6198C6.1314 14.8498 4.62141 14.6098 3.56141 13.8998C2.15141 12.9598 2.15141 11.4198 3.56141 10.4798C4.63141 9.76985 6.1614 9.52984 7.5314 9.76984",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4981 14.8104C12.4381 14.8004 12.3681 14.8004 12.3081 14.8104C10.9281 14.7604 9.82812 13.6304 9.82812 12.2304C9.82812 10.8004 10.9781 9.65039 12.4081 9.65039C13.8381 9.65039 14.9881 10.8104 14.9881 12.2304C14.9781 13.6304 13.8781 14.7704 12.4981 14.8104Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58875 17.961C8.17875 18.901 8.17875 20.441 9.58875 21.381C11.1888 22.451 13.8087 22.451 15.4087 21.381C16.8187 20.441 16.8187 18.901 15.4087 17.961C13.8187 16.901 11.1888 16.901 9.58875 17.961Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.c7ddb06cf53bf9f4890a4ac764bf834c.svg";
export { ForwardRef as ReactComponent };